import React, { Component } from 'react'
import PropTypes from 'prop-types'
import log from 'blazar-sentry'
import styled from 'styled-components'

const PuffWrapper = styled.div`
  .li_footer {
    margin-bottom: 60px;
  }
  .vi_footer {
    padding: 52px 0 44px 0;
  }
  .loaded {
    margin: 0 auto 16px auto;
  }
  iframe {
    width: ${(props) => (props.type.indexOf('footer') > -1 ? 980 : 219)}px;
    height: 0;
  }
`

const scaleIframe = (iframeId, containerId) => {
  const iframeElement = document.getElementById(iframeId)
  const containerElement = document.getElementById(containerId)
  if (iframeElement) {
    const iframeWidth = iframeElement.clientWidth
    const iframeHeight = iframeElement.clientHeight
    const parentWidth = iframeElement.parentNode.clientWidth - 32
    if (iframeWidth === 0 || iframeWidth <= parentWidth) {
      return
    }
    const factor = parentWidth / iframeWidth
    containerElement.style.transform = `scale(${factor.toPrecision(4)})`
    containerElement.style.transformOrigin = 'left top'
    containerElement.style.height = `${Math.round(iframeHeight * factor)}px`
    containerElement.style.padding = '0 16px'
  }
}

class JobPuffs extends Component {
  constructor(props) {
    super(props)
    this.state = { hasMounted: false }
    this.waitingForSize = true

    this.postMessage = (em) => {
      if (!this.waitingForSize) return
      if (em.origin !== 'https://jobb.blocket.se') return

      this.resizeIframe(em)
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.postMessage)
    this.setState({ hasMounted: true })
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.postMessage)
  }

  resizeIframe(em) {
    try {
      const data = JSON.parse(em.data)
      const { type } = this.props
      const adId = `${type}_banner_jobb_iframe`

      if (data.target !== `#${adId}`) return

      const contentId = `${type}_banner_content`

      this.waitingForSize = false

      const target = window.document.querySelector(data.target)
      const content = document.getElementById(contentId)
      const iframeHeight = Number(data.height) + 1
      if (target) {
        target.width = data.width
        target.style.width = `${data.width}px`
        target.height = iframeHeight
        target.style.height = `${iframeHeight}px`
        content.classList.add('loaded')
        scaleIframe(adId, contentId)
      }
    } catch (err) {
      log.error(`failed with ${err}, to resize iframe`)
    }
  }

  render() {
    const { type } = this.props
    const containerId = `${type}_banner_container`
    const contentId = `${type}_banner_content`
    const iframeId = `${type}_banner_jobb_iframe`
    let src = `https://jobb.blocket.se/blocket_puff.html?jparent_appl=${type}`

    // Disabled for now, sending with jcg and jca causes extra history items in Chrome.
    /*
    const currentQuery = queryString.parse(location.search)
    const { cg, r } = currentQuery
    if (cg) {
      src = `${src}&jcg=${cg}`
    }
    if (r) {
      src = `${src}&jca=${r}`
    }
    */

    src = `${src}#${iframeId}`

    return (
      <PuffWrapper type={type}>
        <div id={containerId} className={type}>
          <div id={contentId}>
            {this.state.hasMounted && (
              <iframe
                onLoad={scaleIframe(iframeId, contentId)}
                id={iframeId}
                title="jobpuff"
                src={src}
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                scrolling="no"
                noresize="noresize"
              />
            )}
          </div>
        </div>
      </PuffWrapper>
    )
  }
}

JobPuffs.propTypes = {
  type: PropTypes.string.isRequired,
}

export default JobPuffs
